import { NavItemModel } from '../../common';

export const AGENT_LOGIN_ROUTE_NAME: string = 'agent-login';
export const AGENT_LOGIN_ROUTE_PATH: string = 'agent-login';
export const agentLoginNavItem: NavItemModel = {
  name: AGENT_LOGIN_ROUTE_NAME,
  url: `/${AGENT_LOGIN_ROUTE_PATH}`,
};

export const AGENT_PAGE_ROUTE_NAME: string = 'agent';
export const AGENT_PAGE_ROUTE_PATH: string = 'agent';
export const agentPageNavItem: NavItemModel = {
  name: AGENT_PAGE_ROUTE_NAME,
  url: `/${AGENT_PAGE_ROUTE_PATH}`,
};

export const agentNavigation: NavItemModel[] = [
  agentLoginNavItem,
  agentPageNavItem,
];
